import { render } from "./PartnersHeader.vue?vue&type=template&id=e7a99f74"
import script from "./PartnersHeader.vue?vue&type=script&lang=js"
export * from "./PartnersHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__